const REPUTATION_ACTIONS = ['reputation:viewRelease', 'reputation:viewPage'];

module.exports = {
  REPUTATION_ACTIONS,
};
